import * as yup from 'yup'

export default function (opts) {
  const { required, type } = opts

  let schema =
    type !== 'user' ? yup.array().nullable() : yup.string().nullable()

  if (required) {
    schema = schema.required('这是一个必填项')
  }

  if (type !== 'user' && required) {
    schema = schema.min(1, '这是一个必填项')
  }

  return schema
}
